import PropTypes from '../../_util/vue-types';

export var OptionProps = {
  value: PropTypes.string,
  disabled: PropTypes.boolean,
  children: PropTypes.any
};

export default {
  name: 'Option',
  props: OptionProps,
  render: function render() {
    return null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-mentions/src/Option.js
// module id = null
// module chunks = 